import ButtonComponent from './button-component'
import { BarChartOutlined } from '@ant-design/icons'
import { useGetPreAnalyticData } from '@BUP/hooks/Sociogram/preAnalyticData/useGetPreAnalyticData'
import { capitalizeFirst } from '@BUP/utils'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const ResultsButton = ({ survey, disabled }) => {
  const navigate = useNavigate()
  const i18n = useTranslation()

  const { results, courses } = survey
  const surveyName = courses[0].name

  const hasResults = Boolean(results?.[0])

  const {
    isLoadingPreAnalyticData,
    preAnalyticData,
    errorPreAnalyticData
  } = useGetPreAnalyticData(survey.id)
  const handleViewResult = () => {
    navigate(`/sociogram/dashboard/${survey.id}`,
      {
        state: {
          result: results[0],
          survey,
          courseName: surveyName,
          preAnalyticData
        }
      }
    )
  }

  return (
    <Tooltip
      title={errorPreAnalyticData ? i18n.t('common.resources.sociogram-results.actions.read.failure') : null}
      placement='top'
    >
      <ButtonComponent
        buttonText={capitalizeFirst(i18n.t('common.resources.sociogram-results.title'))}
        icon={<BarChartOutlined />}
        disabled={disabled || errorPreAnalyticData || !hasResults}
        onClick={() => handleViewResult()}
        loading={isLoadingPreAnalyticData}
      />
    </Tooltip>
  )
}

export default ResultsButton
